import memoize from 'memoize-one';
import { Platform } from 'react-native';
export const makeWebStyles = memoize(styles => {
  if (Platform.OS === 'web') {
    return styles;
  }
  return {};
});
export const makeConditionalStyles = memoize((styles, conditional) => {
  if (conditional) {
    return styles;
  }
  return {};
});
export const defaultShadowStyles = Object.freeze({
  shadowOffset: {
    width: 0,
    height: 1
  },
  shadowOpacity: 0.1,
  shadowRadius: 5,
  shadowColor: '#000',
  elevation: 4
});